<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    no-close-on-backdrop
    cancel-title="Cancelar"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <label tag="div">Código</label>
      <b-form-input
        type="text"
        placeholder="Código"
        v-model="form.cd_ocorrencia"
        name="cd_ocorrencia"
      >
      </b-form-input>
      <b-form-feedback
        v-text="form.errors.get('cd_ocorrencia')"
        v-if="form.errors.has('cd_ocorrencia')"
      ></b-form-feedback>

      <label tag="div">Descrição</label>
      <b-form-input
        type="text"
        placeholder="Descrição"
        v-model="form.descr_ocorrencia"
        name="descr_ocorrencia"
      >
      </b-form-input>
      <b-form-feedback
        v-text="form.errors.get('descr_ocorrencia')"
        v-if="form.errors.has('descr_ocorrencia')"
      ></b-form-feedback>

      <label tag="div">Parâmetro de Ocorrência</label>
      <multiselect
        v-model="paramOcorrenciaSelected"
        :options="this.$parent.optionsParamOcorrencia"
        track-by="value"
        label="label"
        :hide-selected="true"
        placeholder="Selecione"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
      ></multiselect>
      <b-form-feedback
        v-text="form.errors.get('parocorren_id')"
        v-if="form.errors.has('parocorren_id')"
      ></b-form-feedback>

      <label tag="div">Status</label>
      <multiselect
        v-model="statusSelected"
        :options="this.$parent.optionsLivStatus"
        track-by="value"
        label="label"
        :hide-selected="true"
        placeholder="Selecione"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
      ></multiselect>
      <b-form-feedback
        v-text="form.errors.get('status')"
        v-if="form.errors.has('status')"
      ></b-form-feedback>

      <label tag="div">Transportadora</label>
      <multiselect
        v-model="transportadoraSelected"
        :options-limit="300"
        :limit="2"
        :limit-text="limitText"
        :options="optionsTransportadora"
        track-by="value"
        label="label"
        id="transportadora"
        :hide-selected="true"
        placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
        :searchable="true"
        :loading="isLoadingTransportadora"
        @search-change="listaTransportadora"
      ></multiselect>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  components: {},
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      statusSelected: [],
      transportadoraSelected: [],
      isLoadingTransportadora: false,
      transportadora: [],
      optionsTransportadora: [],
      paramOcorrenciaSelected: [],
      tpOperacaoaSelected: [],
      form: new Form({
        cd_ocorrencia: "",
        descr_ocorrencia: "",
        parocoori_id: "",
        parocorren_id: "",
        pessoa_id: "",
        status: "",
      }),
      helpForm: new Form({ statusRecord: [], params: [], search: "" }),
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    statusSelected(obj) {
      this.form.status = obj.value;
    },
    transportadoraSelected(obj) {
      this.form.pessoa_id = obj.value;
    },
    paramOcorrenciaSelected(obj) {
      this.form.parocorren_id = obj.value;
    },
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.param_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      console.log(this.$parent.optionsLivStatus[0]);
      // this.statusSelected = {
      //   label: this.$parent.optionsLivStatus[0].label,
      //   value: parseInt(this.$parent.optionsLivStatus[0].value),
      // };
      this.statusSelected = [];
      this.statusSelected = this.$parent.optionsLivStatus[0];
      this.transportadoraSelected = [];
      this.paramOcorrenciaSelected = [];
      this.tpOperacaoaSelected = [];
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.statusSelected = [];
      this.transportadoraSelected = [];
      this.tpOperacaoaSelected = [];
      this.paramOcorrenciaSelected = [];
      this.form.cd_ocorrencia = data.cd_ocorrencia;
      this.form.descr_ocorrencia = data.descr_ocorrencia;
      this.statusSelected = {
        label: data.status.descr,
        value: data.status.valor,
      };
      this.paramOcorrenciaSelected = {
        label: data.param_ocorrencia.cd + " - " + data.param_ocorrencia.descr,
        value: data.param_ocorrencia.parocorren_id,
      };
      if (data.pessoa != null && data.pessoa.pessoa_fisica != null) {
        this.transportadoraSelected = {
          label: data.pessoa.pessoa_fisica.nome,
          value: data.pessoa.pessoa_fisica.pessoa_id,
        };
      }
      if (data.pessoa != null && data.pessoa.pessoa_juridica != null) {
        this.transportadoraSelected = {
          label: data.pessoa.pessoa_juridica.razao_social,
          value: data.pessoa.pessoa_juridica.pessoa_id,
        };
      }
      this.form.param_id = id;
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .put("/api/" + this.rota + "/store")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .patch("/api/" + this.rota + "/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/" + this.rota + "/status")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
        this.isLoadingTransportadora = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/transportadora")
          .then((response) => {
            this.optionsTransportadora = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsTransportadora.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingTransportadora = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;
      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
